import React from "react";
import "./style.css";
export default function ZoomIcon(props) {
    return (React.createElement("div", { className: "zoom-icon-container", onClick: () => {
            props.openZoom();
        } },
        React.createElement("img", { about: "https://uxwing.com/ - super website", src: "../../assets/icons/zoom.svg", height: "30" })));
}
